import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { QueryBuilder } from "react-querybuilder";
import { GET_TAG_TO_FILTER } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";

const modalStyles = {
  color: "white",
  fontWeight: "bold",
  position: "absolute",
  top: 0,
  right: 0,
  width: "58%",
  padding: "2rem",
  height: "100vh",
  backdropFilter: "blur(14.5px)",
  background: "transparent",
  boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
};
const modalStyles_workflow = {
  color: "white",
  fontWeight: "bold",
  position: "absolute",
  top: 0,
  right: 0,
  width: "58%",
  padding: "2rem",
  height: "100vh",
  backdropFilter: "blur(14.5px)",
  background: "black",
  boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
};

const FilterDetailsModal = (props) => {
  const { handleModalClose, Query, modal, type } = props;
  const [TagList, setTagList] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`${GET_TAG_TO_FILTER}`, {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        });
        let filtertags = response?.data.filter_tags;
        setTagList(filtertags);
      } catch (error) {}
    };
    fetchData();
  }, []);
  let fields =
    TagList &&
    TagList.map((option) => ({
      name: option,
      label: option,
    }));

  const NullComponent = () => null;

  return (
    <div>
      <Modal
        className="rounded d-flex justify-content-center align-items-center"
        onClose={handleModalClose}
        open={modal}
      >
        <Box sx={type !== "workflow" ? modalStyles : modalStyles_workflow}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold  mt-2">Query</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={props.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <div>
              <QueryBuilder
                query={JSON.parse(Query)}
                style={{
                  opacity: 1,
                  pointerEvents: "auto",
                  background: "white",
                }}
                disabled={true}
                controlClassnames={{
                  queryBuilder: "queryBuilder-branches",
                  combinatorSelector: "custom-combinator-selector",
                }}
                fields={fields}
                controlElements={{
                  // addGroupAction: NullComponent,
                  removeGroupAction: NullComponent,
                  // addRuleAction: NullComponent,
                  removeRuleAction: NullComponent,
                  // fieldSelector:NullComponent,

                  //  combinatorSelector:
                }}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default FilterDetailsModal;
